import { AppQuery_user as IUser } from 'main/framework/__generated__/AppQuery'
import waitForAnalytics from './wait'

declare var window: any

export function identify(user: IUser): void {
  if (!user) return
  waitForAnalytics(() => {
    const { email, name } = user
    window.analytics.identify(envUserId(user.id), { email, name })

    if (process.env.NODE_ENV === 'development') {
      // tslint:disable-next-line: no-console
      console.log('segment identify', envUserId(user.id), { email, name }) // eslint-disable-line
    }
  })
}

function envUserId(userId: number) {
  if (process.env.NODE_ENV === 'production') return userId
  return `${process.env.NODE_ENV}-${String(userId)}`
}
